import api from '../client'

function idempotencyHeaders(idempotencyKey) {
  return idempotencyKey
    ? { headers: { 'Idempotency-Key': idempotencyKey } }
    : undefined
}

export const parlayApi = {
  list: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/feed/parlays`, { params })
    return response.data
  },

  get: async (orgSlug, postId) => {
    const response = await api.get(`/${orgSlug}/feed/parlays/${postId}`)
    return response.data
  },

  evaluate: async (orgSlug, payload, idempotencyKey) => {
    const response = await api.post(
      `/${orgSlug}/feed/parlays/evaluate`,
      payload,
      idempotencyHeaders(idempotencyKey),
    )
    return response.data
  },

  create: async (orgSlug, payload, idempotencyKey) => {
    const response = await api.post(
      `/${orgSlug}/feed/parlays`,
      payload,
      idempotencyHeaders(idempotencyKey),
    )
    return response.data
  },

  update: async (orgSlug, postId, payload, idempotencyKey) => {
    const response = await api.patch(
      `/${orgSlug}/feed/parlays/${postId}`,
      payload,
      idempotencyHeaders(idempotencyKey),
    )
    return response.data
  },

  refresh: async (orgSlug, postId, idempotencyKey) => {
    const response = await api.post(
      `/${orgSlug}/feed/parlays/${postId}/evaluate`,
      {},
      idempotencyHeaders(idempotencyKey),
    )
    return response.data
  },

  publishGeneratedDraft: async (orgSlug, postId, idempotencyKey) => {
    const response = await api.post(
      `/${orgSlug}/feed/parlays/${postId}/publish`,
      {},
      idempotencyHeaders(idempotencyKey),
    )
    return response.data
  },


  getSettings: async (orgSlug, offeringId) => {
    const response = await api.get(`/${orgSlug}/feed/parlay-settings`, {
      params: { offering_id: offeringId },
    })
    return response.data
  },

  updateSettings: async (orgSlug, payload) => {
    const response = await api.patch(`/${orgSlug}/feed/parlay-settings`, payload)
    return response.data
  },

}
